import React from 'react'
import { func, instanceOf } from 'prop-types'

import DatePicker from 'coact/DatePicker'

function CustExchanger ({ exportDate, setExportDate, onDownload }) {
  return (
    <div>
      匯出日期
      <DatePicker
        value={exportDate}
        onChange={setExportDate}
      />
      <button
        className="btn btn-primary"
        onClick={() => onDownload('BAO_DAO')}
      >
        寶島出貨
      </button>
      <button
        className="btn btn-primary"
        onClick={() => onDownload('BAO_DAO_PROCESS')}
      >
        寶島加工
      </button>
      <button
        className="btn btn-primary"
        onClick={() => onDownload('XIAO_LIN')}
      >
        小林銷售
      </button>
      <button
        className="btn btn-primary"
        onClick={() => onDownload('XIAO_LIN_CONSIGNMENT')}
      >
        小林寄賣
      </button>
    </div>
  )
}

CustExchanger.propTypes = {
  exportDate: instanceOf(Date),
  setExportDate: func,
  onDownload: func,
}

export default CustExchanger



// WEBPACK FOOTER //
// ./src/components/CustExchanger/CustExchanger.jsx